import { createSlice } from "@reduxjs/toolkit";

/* eslint-disable no-param-reassign */
const initialState = {
  practiceName: "",
  practiceEmail: "",
  speciality: "",
  accountType: "",
  salesPerson: "",
  customerId: "",
  channel: "",
  alert: "",
  healthScore: "",
  currentPage: 1,
};

export const clientFilterSlice = createSlice({
  name: "clientFilter",
  initialState,
  reducers: {
    setPracticeName: (state, action) => {
      state.practiceName = action.payload;
    },
    setPracticeEmail: (state, action) => {
      state.practiceEmail = action.payload;
    },
    setSpeciality: (state, action) => {
      state.speciality = action.payload;
    },
    setAccountType: (state, action) => {
      state.accountType = action.payload;
    },
    setClientSalesPerson: (state, action) => {
      state.salesPerson = action.payload;
    },
    setCustomerClientId: (state, action) => {
      state.customerId = action.payload;
    },
    setChannel: (state, action) => {
      state.channel = action.payload;
    },
    setAlert: (state, action) => {
      state.alert = action.payload;
    },
    setHealthScore: (state, action) => {
      state.healthScore = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    clearFilters: (state) => {
      state.practiceName = "";
      state.practiceEmail = "";
      state.speciality = "";
      state.accountType = "";
      state.salesPerson = "";
      state.customerId = "";
      state.channel = "";
      state.alert = "";
      state.healthScore = "";
    },
    setAllFilters: (state, action) => {
      state.practiceName = action.payload.practiceName;
      state.practiceEmail = action.payload.practiceEmail;
      state.speciality = action.payload.speciality;
      state.accountType = action.payload.accountType;
      state.salesPerson = action.payload.salesPerson;
      state.customerId = action.payload.customerId;
      state.channel = action.payload.channel;
      state.alert = action.payload.alert;
      state.healthScore = action.payload.healthScore;
      state.currentPage = action.payload.currentPage;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setPracticeName,
  setPracticeEmail,
  setSpeciality,
  setAccountType,
  setClientSalesPerson,
  setCustomerClientId,
  setChannel,
  setAlert,
  setHealthScore,
  setCurrentPage,
  clearFilters,
  setAllFilters,
} = clientFilterSlice.actions;

export default clientFilterSlice.reducer;
